
export class DeleteDancePartnerSearchPostingImageRequestDto {
  url: string;
}
